export default {
  getCurrentTrainerSurveyEntries: state => state.trainer_survey_entries
}
